<ca-modal-container
    modalTitle="{{ 'MODULES.SPEC_GENERATION.MODAL_TITLE' | translate }}"
    description="{{ 'MODULES.SPEC_GENERATION.MODAL_DESCRIPTION' | translate }}"
    (dismiss)="dismiss()"
    class="ca-module-editor-modal"
>
    <div class="d-flex justify-content-start sm-vw-responsive">
        <div>
            <ca-module-spec-visualiser
                [specification]="specification$ | async"
                [moduleTitle]="moduleTitle"
                [isFormValid]="isFormValid"
                [isReadonly]="propertyDefinitionComplete"
                [propertyDefinitionComplete]="propertyDefinitionComplete"
                (onAddInputOutput)="addInputOutput($event)"
                (onRemoveInputOutput)="removeInputOutput($event)"
                (onSetActiveProp)="setActiveProp($event)"
            >
            </ca-module-spec-visualiser>
        </div>
        <div class="d-flex justify-content-center flex-column w-100 mt-lg-0 mt-md-3 mt-sm-3 mt-xs-3">
            <ca-module-spec-editor-new
                class="d-flex justify-content-center"
                [propertyDefinitionComplete]="propertyDefinitionComplete"
                (onFormValidityChange)="handleFormValidityChanged($event)"
            >
            </ca-module-spec-editor-new>
            <footer class="d-flex justify-content-end mt-auto">
                <button
                    type="button"
                    *ngIf="!propertyDefinitionComplete"
                    class="btn btn-primary mt-3"
                    data-uit="next-button"
                    [disabled]="!isFormValid"
                    (click)="next()"
                >
                    {{ 'GENERAL.NEXT' | translate }}
                </button>
                <button type="button" *ngIf="propertyDefinitionComplete" class="btn btn-secondary" (click)="previous()">
                    {{ 'GENERAL.BACK' | translate }}
                </button>
                <button
                    type="button"
                    *ngIf="propertyDefinitionComplete"
                    class="btn btn-primary btn-download ms-3"
                    caAutoFocus
                    data-uit="download-button"
                    (click)="download()"
                >
                    {{ 'GENERAL.DOWNLOAD' | translate }}
                </button>
            </footer>
        </div>
    </div>
</ca-modal-container>
